import React from 'react';
import '../styles.css';

function WelcomeDialog({ onClose, navigate }) {
  const handleAddVehicleClick = () => {
    navigate('/vehicle-editor/new');
  };

  const handleCircuitManagerClick = () => {
    navigate('/circuit-manager');
  };

  const handleHelpClick = () => {
    navigate('/help');
  };

  return (
    <div className="confirmation-dialog-overlay">
      <div className="confirmation-dialog welcome-dialog">
        <h2>Welcome To Hot Setup!</h2>
        <p>Start by creating a vehicle with <button onClick={handleAddVehicleClick} className="welcome-link">Add Vehicle</button>, where you will add all of the specific parameters for your vehicle's setup. Organize them into groups and arrange them in a way that makes sense for you.</p>

        <p>Next, visit the <button onClick={handleCircuitManagerClick} className="welcome-link">Circuit Manager</button> to load in the circuits you visit often. We already have a large database of circuits, but you can always also create your own.</p>

        <p>After that, create an <strong>Event</strong> and then a <strong>Session</strong>. Here you'll fill in your setup sheet, and can then enter the session where you can keep track of your session with lap timing, live weather details, and notes.</p>

        <p>Visit the <button onClick={handleHelpClick} className="welcome-link">Help Section</button> for more tips! We've also created an example Vehicle, Event and Session to help you get started.</p>

        <p>Welcome to Hot Setup, we're happy to be part of your motorsport journey!</p>
        <div className="confirmation-dialog-actions">
          <button onClick={onClose} className="btn btn-save">
            OK, I've got it.
          </button>
        </div>
      </div>
    </div>
  );
}

export default WelcomeDialog;